<template>
  <div>
  <div class="xurigoucartpage" :style="{height:defaultHeight+'px'}">
    <mu-appbar class="XR-tab-head fixed">
      <mu-icon-button v-on:click="GoHistory" icon=":fa fa-angle-left" slot="left"/>        
      <!-- <mu-icon-button icon="menu" slot="left"/> -->
      <div class="head-content">
        <p style="font-size:16px;">购物车</p>
        <p style="font-size:12px;">共{{totalCount}}件宝贝</p>
      </div>
      <mu-flat-button :label="mode == 'normal'?'编辑':'完成'" slot="right" ref="head" @click="editEvent" />
    </mu-appbar>
   <!-- <div class="all-chk"><mu-checkbox class="cart-all-chk" :nativeValue="cartItem.ShopId" @change="shopClick(cartItem.ShopId)" uncheckIcon=":fa fa-circle-thin" checkedIcon=":fa fa-yes"/></div> -->
  <div style="margin-bottom:56px;">
  <template v-for="cartItem in productList" >
    <div class="cart-list" v-if="!loaded && productList.length>0" :key="cartItem.ShopId">
      <div class="cart-item">
        <div class="shopRow">          
          <div class="shopName">
            <img :src="cartItem.ShopLogo" class="shopimg"/>
            <span style="color: #000;">{{cartItem.ShopName}}</span>
            <span class="getcoupon" @click="openCouponSheet(cartItem.ShopId)" v-if="isShopCouponCanGet(cartItem.ShopId) && !closeCoupon">领 券</span>
          </div>    
        </div>
        <div class="pro-list">
          <div class="pro-item" v-for="productItem in cartItem.Products" :key="productItem.SkuId">
            <div class="chk">
              <mu-checkbox class="cart-chk" :nativeValue="productItem.SkuId.toString()" v-model="checkList"  uncheckIcon=":fa fa-circle-thin" checkedIcon=":fa fa-yes"/>
            </div>
            <div class="pro-img">
              <router-link :to="'/retail/productDetail?skuId='+productItem.SkuId"><img :src="productItem.DefaultImg?productItem.DefaultImg:IMGServer_URL+'/images/index-item-default.png'" /></router-link>
            </div>
            <div class="pro-info" :style="{width:cartItemProductInfoWidth+'px'}">
              <router-link :to="'/retail/productDetail?skuId='+productItem.SkuId"><p class="pro-name">{{productItem.Name}}</p></router-link>
              <p class="pro-attr" style="overflow:hidden;">
                <template v-for="attrItem in productItem.Attrs">
                  {{attrItem.AttrName +":" + attrItem.AttrValue}} 
                </template>
              </p>
              <div class="pro-num">
                <p class="pro-price">
                  <template v-if="productItem.State==0">
                    <i class="fa fa-rmb"></i>{{productItem.SalePrice.toFixed(2)}}
                  </template>
                  <template v-else>
                    商品已下架
                  </template>
                </p>
                <div class="jiajian-ctrl">
                  <span class="btn jian" @click="minusCartItem(productItem.SkuId, productItem.Stock)">-</span>
                  <span class="count">{{getCartItemCount(productItem.SkuId)}}</span>
                  <span class="btn jia" @click="plusCartItem(productItem.SkuId, productItem.Stock)">+</span>
                </div>
              </div>
            </div>
          </div>
          <div class="shop_list" v-if="isCouponInfo(cartItem.ShopId) && !closeCoupon">
            <div class="proshop">
            <span class="shopcoupon">本店活动</span>
            <span class="shopcouponremark">下单领券，可享受{{GetCouponInfo(cartItem.ShopId).FullMoney}}减{{GetCouponInfo(cartItem.ShopId).DiscountMoney}}店铺优惠券</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </template>
  </div>
      <mu-divider />
      <div class="bottom-bar">
        <mu-row >
          <mu-col width="65" tablet="65" desktop="65">
            <div class="cart-all-chk">            
              <mu-checkbox label="全选" @change="checkAll()" v-model="checkAllState" uncheckIcon=":fa fa-circle-thin" checkedIcon=":fa fa-yes"/>
            </div>
            <div style="width:50%;height:56px;" v-if="mode == 'normal'">
              <div class="cart-money" :style="{height:moneyheight+'px',lineHeight:moneyheight+'px'}">
                <p class="cart-total">
                  <span>合计:<i class="fa fa-rmb">{{totalPrice - storeCouponMoney}}</i></span>
                  <!-- <span class="money">{{(totalPayPrice-bawDiscountTotalPrice).toFixed(2)}}</span> -->
                </p>
              </div>
              <div class="cart-discount" v-if="storeCouponMoney>0">
                <p>店铺减<i class="fa fa-rmb"></i>{{storeCouponMoney}}</p>
              </div>
            </div>
            <div style="width:30%;height:56px;" v-if="mode == 'normal'">
			  <!--couponbtn-->
              <mu-flat-button :label="'领券结算('+totalCount+')'" v-if="storeCouponMoney > 0"  class="gobuy" backgroundColor="red" color="white" fullWidth @click="goToBuy" />
              <mu-flat-button :label="'结算('+totalCount+')'" v-if="storeCouponMoney == 0"  class="gobuy" backgroundColor="red" color="white" fullWidth @click="goToBuy" />
            </div>
            
            <template v-if="mode != 'normal'">
              <div style="width:80%;height:56px;">
                <mu-flat-button class="operatorBtn" backgroundColor="red" color="white" @click="deleteCart()" label="删除" fullWidth></mu-flat-button>
                <mu-flat-button class="operatorBtn" backgroundColor="#FF2F66" color="white" @click="clearCart()" label="清空" fullWidth></mu-flat-button>
              </div>
            </template>
          </mu-col>
        </mu-row>
    </div>
    <XR-toast ref="XRtoast"></XR-toast>
    <mu-dialog :open="dialog" title="确定要删除吗" @close="close">      
      <mu-flat-button slot="actions" @click="close" backgroundColor="red" color="white" primary label="取消"/>
      <mu-flat-button slot="actions" primary @click="removeCartItem()" label="确定"/>
    </mu-dialog>
    
    <mu-bottom-sheet :open="couponSheet" @close="closeCouponSheet">    
      <div class="pagecart-retailSheet">
        <div  v-for="couponRow in shopCouponList" :key="couponRow.Id" class="coupon_default_inner"> 
          <template > 
            <div :class="(percent(couponRow.Money/couponRow.FullMoney) >=100 ? 'couponGrey' : (couponRow.Type== 0? 'couponRink':'couponYellow'))" class="couponLeft">
                <div class="coupon_discount" >
                    <p class="cost">￥</p>
                    <p class="money">{{couponRow.Money}}</p>
                </div>
            </div>
            <div class="couponRight" :class="(percent(couponRow.Money/couponRow.FullMoney) >=100 ? 'couponGrey' : (couponRow.Type==0? 'couponRink':'couponYellow'))">              
              <div class="coupon_content" :style="{width:couponWidth+'px'}">
                <p class="coupon_title">
                  <span class="coupon_type">店铺优惠券</span> {{couponRow.Name}}
                </p>
                <p class="limit">
                    使用门槛：满{{couponRow.FullMoney}}元可用
                    <span v-if="couponRow.ReceiveStatus=='已领取'" style="float: right;margin-right: 14px;">已领取</span>
                </p>
                <div class="coupon_progress">
                  <mu-linear-progress mode="determinate" :value="percent(couponRow.ReceiveAmount/couponRow.TotalAmount)"/>
                  <span class="percent">{{percent(couponRow.ReceiveAmount/couponRow.TotalAmount)+'%'}}</span>
                  <template v-if="couponRow.ReceiveStatus==0">
                    <template v-if="couponRow.ReceiveAmount==couponRow.TotalAmount">
                      <span class="coupon_empty">已抢光</span>
                    </template>
                    <template v-if="couponRow.ReceiveAmount < couponRow.TotalAmount && couponRow.MemberTotalReceiveAmount < couponRow.EveryoneAmount" >                      
                      <mu-flat-button @click="receiveCoupon(couponRow.Id)" label="点击领取" class="demo-flat-button" primary/>
                    </template>
                  </template>
                  <template v-if="couponRow.ReceiveStatus==1">
                    <mu-flat-button @click="goToCouponUsing(couponRow.Id)" label="去使用" class="demo-flat-button" primary/>
                  </template>
                </div>               
              </div>
            </div>
          </template>
        </div>
    </div>
    </mu-bottom-sheet>
    <XR-PageTip ref="XRPageTip"></XR-PageTip>
  </div>
  </div>
</template>

<script>
import cart from '../../util/cart'
export default {
  data () {
    return {
      loaded:true,
      dialog: false,
      fullHeight: (parseInt(document.documentElement.clientHeight)+96),
      cartItemProductInfoWidth: (parseInt(document.documentElement.clientWidth)-130),
      cartList: [],
      productList:[],
      deleteSkuId : 0,
      checkList:[],
      skuList:[],
      skuPriceList:[],
      checkAllState:true,
      moneyheight:30,
      totalPrice:0,
      totalCount:0,
      storeCouponMoney:0,//店铺优惠金额
      couponbtn:true,
      couponWidth: document.documentElement.clientWidth-20-60-16, //优惠券宽度
      shopCouponList:{}, //优惠券列表
      shopCouponCanGetList:{}, //优惠券可领列表
      couponSheet:false, //控制领券弹框显示

      mode: this.$route.query.mode?this.$route.query.mode:'normal', //如果mode=normal，则代表正常，如果mode=select，则代表选择模式，选中即跳转回去
      editButtonShow: this.$route.query.mode == 'select' ?false:true,
	  defaultHeight: (parseInt(document.documentElement.clientHeight)-56),
    }
  },
  mounted:function(){
    this.$postBase(
      this.MOBILE_URL + "/Oauth2/WeChat/wechat.ashx"
      ).then(function(res) {
      if(!res.IsSuccess){
          //ths.$refs.XRtoast.failed(res.Msg, true)
      }else{
          wx.config({
              debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
              appId: res.Data.AppId, // 必填，公众号的唯一标识
              timestamp: res.Data.TimeStamp, // 必填，生成签名的时间戳
              nonceStr: res.Data.NonceStr, // 必填，生成签名的随机串
              signature: res.Data.Sign, // 必填，签名，见附录1
              jsApiList: [] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
          });
          wx.ready(function () {
              WeixinJSBridge.call('hideOptionMenu');
          });
      }
    });
    this.$refs.XRtoast.load()
    this.getCartList()
  },
  methods: {
    open () {
      this.dialog = true
    },
    close () {
      this.dialog = false
    },
    checkAll(){
      if(!this.checkAllState){        
        this.checkList = this.skuList
      }else{
        this.checkList = []
      }
    },
    GoHistory(){
      this.$router.goBack()
    },
    getCartList: function(){
      this.cartList = cart.getList()
      if(this.cartList.length ==0){
        this.editButtonShow = false
        this.productList =[]
        this.$refs.XRtoast.hide()
        this.$refs.XRPageTip.ShowEmpty('购物车为空')
        return
      }
      var data = {skuIds:[]}
      for(var i =0; i< this.cartList.length ; i++){
        data.skuIds.push(this.cartList[i].skuId)
      }
      this.skuList = data.skuIds

      var ths = this;   
      ths.$post(
        "/Shop/RetailServer/GetCartProductList",
        JSON.stringify(data)
      ).then(function(res) {
        if(!res.IsSuccess){
          ths.$refs.XRtoast.failed(res.Msg, true)
          ths.$refs.XRPageTip.ShowEmpty('购物车为空')
        }else{      
          ths.productList = res.Data
          ths.skuPriceList = []
          for(var i = 0; i<ths.productList.length;i++){
            for(var j = 0; j< ths.productList[i].Products.length;j++){
              ths.skuPriceList.push({skuId: ths.productList[i].Products[j].SkuId, price: ths.productList[i].Products[j].SalePrice})
            }
          }
          ths.checkList = ths.skuList
          ths.$refs.XRtoast.hide()
          ths.$refs.XRPageTip.initTip()
          ths.loaded = false
        }
      });
    },
    //获取店铺优惠券
    getShopCoupon:function(){
	  if (this.closeCoupon){
	    return
	  }
      var list = cart.getList()
      var skuCountList = []
      for(var i = 0; i< this.productList.length; i++){
        for(var j = 0; j< this.productList[i].Products.length; j++){
		  //判断有没有选中
		  for(var k =0;k<list.length;k++){
			if(list[k].select && list[k].skuId == this.productList[i].Products[j].SkuId){
				skuCountList.push({skuId: this.productList[i].Products[j].SkuId, count: this.getCartItemCount(this.productList[i].Products[j].SkuId),activityType:0 })
				break
			}
		  }
        }
      }
	  if (skuCountList.length == 0){
		return;
	  }
      var ths = this;   
      ths.$post(
        "/Shop/CouponServer/WapCartByStoreCoupon",
        JSON.stringify({SkuIds: skuCountList})
      ).then(function(res) {
        if(res.IsSuccess){		  
          //ths.storeCouponMoney = res.Data.AllMoney
		  ths.storeCouponMoney = 0
          if(res.Data.StoreCouponItem){		    
            ths.shopCouponCanGetList = res.Data.StoreCouponItem
            ths.isCouponBtn()			
			console.log(list)
			console.log(ths.productList)
			var	shopIds = []
			for (var i=0;i<ths.shopCouponCanGetList.length;i++){			  
				for(var j =0;j<list.length;j++){
					if(list[j].select){
						for(var k =0;k<ths.productList.length;k++){
							for(var l =0;l<ths.productList[k].Products.length;l++){
								if (ths.productList[k].ShopId == ths.shopCouponCanGetList[i].ShopId && ths.productList[k].Products[l].SkuId == list[j].skuId && !shopIds[ths.productList[k].ShopId]){
									ths.storeCouponMoney += ths.shopCouponCanGetList[i].DiscountMoney
									shopIds[ths.productList[k].ShopId] = true
									break;
								}
							}
						}
					}
				}
			}
          }
          
          if(ths.storeCouponMoney==0)
          {
            ths.moneyheight=41
          }
          if(ths.storeCouponMoney>0){
            ths.moneyheight=30
          }
		  console.log(res.Data)		  
        }
      })
    },
    //判断是否有可使用的店铺优惠券
    isCouponInfo(shopId){
      for(var i = 0; i< this.shopCouponCanGetList.length; i++){
	    if(this.shopCouponCanGetList[i].ShopId == shopId){
			if(this.shopCouponCanGetList[i].DiscountMoney > 0){
				return true
			}
		}
      }
      return false
    },
    //判断是否显示领券结算
    isCouponBtn(){
      var couponbtnlist=true
      for(var i=0;i<this.shopCouponCanGetList.length;i++)
           {
             if(this.shopCouponCanGetList[i].ReceiveCouponItem.length>0)
             {
               couponbtnlist=false
             }
           }
           this.couponbtn=couponbtnlist
    },
    //获取店铺可用优惠券
    GetCouponInfo(shopId){
      for(var i = 0; i< this.shopCouponCanGetList.length; i++){
        if(this.shopCouponCanGetList[i].ShopId == shopId){
          return this.shopCouponCanGetList[i]
        }
      }
      return {}
    },
    //判断是否可领取店铺优惠券
    isShopCouponCanGet:function(shopId){
      for(var i = 0; i< this.shopCouponCanGetList.length; i++){
		if (this.shopCouponCanGetList[i].ShopId == shopId){
			if(this.shopCouponCanGetList[i] && this.shopCouponCanGetList[i].ReceiveCouponItem && this.shopCouponCanGetList[i].ReceiveCouponItem.length>0){
				return true
			}
		}        
      }
      return false
    },
    getCartItemCount: function(skuId){
      for(var i = 0; i < this.cartList.length; i++){
        if(this.cartList[i].skuId == skuId){
          var cnt = this.cartList[i].count
          return cnt
        }
      }
      return 0
    },
    plusCartItem: function(skuId){
      cart.addItem(skuId,1)
      this.cartList = cart.getList()
    },
    minusCartItem: function(skuId){
      if(this.getCartItemCount(skuId)-1 == 0){
        this.deleteSkuId = skuId
        this.open()
        return
      }
      cart.minusItem(skuId)
      this.cartList = cart.getList()
    },
    removeCartItem: function(){
      this.dialog = false
      if(this.deleteSkuId == 0){
        return
      }
      
      cart.removeItem(this.deleteSkuId)
      this.getCartList()
    },
    goToBuy(){
      if(this.checkList.length ==0){
        this.$refs.XRtoast.failed("未勾选要购买的商品", true)
        return
      }
      this.$router.push('/retail/orderSubmit')
    },
    getPriceTotal(){
      var check = this.checkList
      var list = cart.getList()
      for(var i = 0; i< list.length;i++){
        cart.checkItem(list[i].skuId, false)
        for(var j = 0; j< check.length;j++){
          if(list[i].skuId == check[j]){
            cart.checkItem(list[i].skuId, true)
          }
        }
      }

      var price = 0
      var cnt = 0
	  var storeCouponMoney = 0
      list = cart.getList()
	  var shopIds = []
      for(var i =0;i<list.length;i++){
        if(list[i].select){
          for(var j = 0; j< this.skuPriceList.length; j++){
            if(list[i].skuId == this.skuPriceList[j].skuId){
              cnt += list[i].count
              price += list[i].count * this.skuPriceList[j].price
            }
          }

          //更新店铺券抵用价格
          for (var j=0;j<this.shopCouponCanGetList.length;j++){
            for(var k =0;k<this.productList.length;k++){
              for(var l =0;l<this.productList[k].Products.length;l++){
                if (this.productList[k].ShopId == this.shopCouponCanGetList[j].ShopId && this.productList[k].Products[l].SkuId == list[i].skuId && !shopIds[this.productList[k].ShopId]){
                  storeCouponMoney += this.shopCouponCanGetList[j].DiscountMoney
				  shopIds[this.productList[k].ShopId] = true
                  break;
                }
              }
            }
		  }
		  
        }
      }
      this.totalCount = cnt
      this.totalPrice = price
	  
	  //优惠券价格更新
	  this.storeCouponMoney = storeCouponMoney
	  
	  //更新高度
	  if(this.storeCouponMoney==0)
	  {
		this.moneyheight=41
	  }
	  if(this.storeCouponMoney>0){
		this.moneyheight=30
	  }
	  
	  this.getShopCoupon()
	  
    },    
    editEvent: function(){
      if(this.mode == 'edit'){
        this.mode='normal';
      }else{
        this.mode='edit';
      }
      this.isCouponBtn()
    },
    deleteCart(){
      if(this.checkList.length==0){
        this.$refs.XRtoast.failed("未勾选要删除的商品", true)
        return
      }
      cart.clearSelectList()
      this.isCouponBtn()
      this.getCartList()
    },
    clearCart(){
      cart.clearList()
      this.getCartList()
    },
    
    receiveCoupon(num){
      if (!this.$store.state.user.SessionId) {
        this.loginUrl = "/Login";
		this.$router.push(this.loginUrl+"?redirect="+encodeURIComponent(this.$router.history.current.fullPath)+"&msg="+encodeURIComponent("请先登录再领券"));
        return;
      }else{
        var ths = this;
        ths.$post('/Shop/CouponServer/WapReceiveCoupon',{'CouponId':num}
        ).then(function (res) {
          if(!res.IsSuccess){
            ths.$refs.XRtoast.failed(res.Msg, true)
          }else{
            ths.closeCouponSheet()
            ths.getShopCoupon()
          }
        })
      }
    },
	goToCouponUsing(id){
      this.$router.push('/retail/coupon/couponUsingRemark?id='+id)
    },
    openCouponSheet(shopId){
      this.shopCouponList = []
      for(var i = 0; i< this.shopCouponCanGetList.length;i++){
        if(shopId == this.shopCouponCanGetList[i].ShopId){
          for(var j = 0 ;j < this.shopCouponCanGetList[i].ReceiveCouponItem.length;j++){            
            this.shopCouponList.push(this.shopCouponCanGetList[i].ReceiveCouponItem[j]) 
          }
        }
      }
      this.couponSheet =true
    },
    closeCouponSheet(){
      this.couponSheet =false
    },
    percent(obj){
      return (obj * 100).toFixed(2);
    },
  },
  watch:{
    checkList(){
      if(this.checkList.length != this.skuList.length){
        this.checkAllState = false
      }else{
        this.checkAllState = true
      }
      this.getPriceTotal()
    },
    cartList(){
      this.getShopCoupon()
      this.getPriceTotal()
    }
  }
}
</script>
<style>
.xurigoucartpage .shopimg{border-radius:50%;width:20px;height:20px;float:left;margin:12px 5px 0px 0px;}
.xurigoucartpage .shop_list{width:100%;height:50px;padding:0px 10%;background-color: white;}
.xurigoucartpage .shopcoupon{border:1px solid #FAB5B2;padding:2px;color:#DF1C3E;font-weight:600;border-radius: 3px;font-size: 12px;}
.xurigoucartpage .shopcouponremark{color:#7C7C7C;width:40px;padding-left:10px;font-weight:600;font-size: 12px;}
.xurigoucartpage .proshop{width:100%;height:50px;line-height:50px;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;}
.xurigoucartpage .getcoupon{background-image:url('/static/1.png');color:white;margin-top:10px;line-height:15px;padding:2px 7px;margin-right:15px;float:right;height:15px;font-size: 12px;background-size: 100% 100%;background-repeat: no-repeat;}
.xurigoucartpage .XR-tab-head .head-content{
  /* border:1px solid; */
  width: 50%;
  overflow: hidden;
  line-height: 20px;
}
.xurigoucartpage .XR-tab-head.fixed{  
  padding:0;
  top:0;
  left: 0;
  
}
.xurigoucartpage .gobuy{
  float: right;
  width: 100%;
  line-height: 56px;
  height: 56px;
  text-align: center;
}
.xurigoucartpage .gobuy  .mu-flat-button-label{line-height: 56px;padding-left: 0;padding-right: 0;}

.xurigoucartpage .bottom-bar{
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background: white;
  height: 56px;
  border-top:1px solid #eee;
  z-index: 9999;
}
.xurigoucartpage .bottom-bar .cart-money{
  overflow: hidden;
  font-size: 15px;
  padding-top: 8px;
  padding-right: 10px;
}
.xurigoucartpage .bottom-bar .cart-money .cart-freightMoney{
  float: right;
  color:#A1A1A1;
  font-size: 10px;
  margin-right: 5px;
}
.xurigoucartpage .bottom-bar .cart-money .cart-total{
  float: right;
  font-size: 15px;
  font-weight: 550;
  color:black;
}
.xurigoucartpage .bottom-bar .cart-money .cart-total i.fa{
  color:Red;
}
.xurigoucartpage .bottom-bar .cart-money .cart-total .money{
  color:Red;
}
.xurigoucartpage .bottom-bar .cart-discount{
  float: right;
  font-size: 13px;
  color:Red;
  height: 20px;
  line-height: 20px;
  padding-right: 10px;
}
.xurigoucartpage .bottom-bar .cart-all-chk{
  float: left;
  width: 20%;
  text-align: left;
  height: 24px;
  margin: 16px 0;
} 
.xurigoucartpage .mu-checkbox-icon {
    width: 24px;
    height: 24px;
    vertical-align: middle;
    position: relative;
    /* margin-right: ; */
}
.xurigoucartpage{
  background: #F0F2F5;
  margin-bottom: 56px;
}

.xurigoucartpage .cart-list{
  overflow: hidden;
  margin-top: 15px;
  border-radius: 10px;
}
.xurigoucartpage .cart-item{
  background: white;
}


.xurigoucartpage .shopRow{
  background:white;
  overflow: hidden;
  color:#666;
  width: 100%;
  line-height: 40px;
  height: 40px;
}
.xurigoucartpage .shopRow .all-chk{
  float: left;
  width: 40px;
  margin-top: 6px;
  text-align: center;
}
.xurigoucartpage .shopRow .shopName{
  padding-left: 10px;
}

.xurigoucartpage .pro-list{
  background: #fcfcfc;
  overflow: hidden;
}
.xurigoucartpage .pro-list .pro-item{
  padding: 16px 0;
  overflow: hidden;
}
.xurigoucartpage .pro-list .pro-item .chk{
  width: 40px;
  text-align: center;
  line-height: 80px;
  float: left;
}

.xurigoucartpage .pro-list .pro-item .pro-img{
  width: 80px;
  float: left;
}
.xurigoucartpage .pro-list .pro-item .pro-img img{
  width: 100%;
  display: block;
  border-radius: 4px;
  height: 80px;
  object-fit: cover;
}
.xurigoucartpage .pro-list .pro-item .pro-info{
  float: right;
  padding-right: 10px;
}
.xurigoucartpage .pro-list .pro-item .pro-info .pro-name{
  font-size: 14px;
  line-height: 16px;
  height: 32px;
  padding-bottom: 4px;
  overflow: hidden;
  color:#aeaeae;
}
.xurigoucartpage .pro-list .pro-item .pro-info .pro-attr{
  font-size: 12px;
  line-height: 16px;
  height: 30px;
  color:#b0b0b0;
}
.xurigoucartpage .pro-list .pro-item .pro-info .pro-num{
  font-size: 12px;
  line-height: 16px;
  height: 16px;
  color:#999;
}
.xurigoucartpage .pro-list .pro-item .pro-info .pro-num .pro-price{
  font-size: 16px;
  line-height: 16px;
  color:#999;
  float: left;
  color:red;
}
.xurigoucartpage .pro-list .pro-item .pro-info .pro-num .pro-price .fa{
  font-size: 12px;
}
.xurigoucartpage .pro-list .pro-item .pro-info .pro-num .jiajian-ctrl{
  float: right;
}
.xurigoucartpage .pro-list .pro-item .pro-info .pro-num .jiajian-ctrl span{
  float: left;
  width: 20px;
  text-align: center;
}
.xurigoucartpage .pro-list .pro-item .pro-info .pro-num .jiajian-ctrl .count{
  border: 1px solid #eee;
  width: 30px;
  border-left: 0;
  border-right: 0;
}
.xurigoucartpage .pro-list .pro-item .pro-info .pro-num .jiajian-ctrl .btn{
  border: 1px solid #eee;
}
.xurigoucartpage .pro-list .pro-item .pro-info .pro-num .jiajian-ctrl .jian{
  border-radius:2px 0 0 2px;
}
.xurigoucartpage .pro-list .pro-item .pro-info .pro-num .jiajian-ctrl .jia{
  border-radius:0 2px 2px 0;
}
.xurigoucartpage .no-gutter .desktop-65 .operatorBtn:nth-child(2){
  float:right;
  /* margin-right:0px;  */
}
.xurigoucartpage .no-gutter .desktop-65 .operatorBtn{height: 56px;float:right;}
.xurigoucartpage .mu-flat-button{
  border-radius: 0;
}
.xurigoucartpage .no-gutter .desktop-65{display: flex;width: 100%;}
.xurigoucartpage .no-gutter .desktop-65 .mu-checkbox{margin-left: 5%}


.pagecart-retailSheet {
    width: 100%;
    padding: 10px;
    background: #f5f5f5;
    height: 50vh;
    overflow: auto;
  }
.pagecart-retailSheet  .coupon_default_inner{
    width: 100%;
    display: flex;
    margin-top: 10px;
    background-size: 100% 100%; 
  }
.pagecart-retailSheet   .coupon_default_inner:first-child{
    margin-top: 0;
  }
.pagecart-retailSheet  .coupon_default_inner .couponLeft{
    padding: 10px 0;
    background-size:100% 100%; 
  }
.pagecart-retailSheet  .coupon_default_inner .couponLeft .coupon_discount{
    width: 60px;
    height: 60px;
    text-align: center;
    color: #fff;
    border-radius: 50%;
    margin: 0 8px;
    margin-top: 8px;
  }
.pagecart-retailSheet  .coupon_default_inner .couponLeft.couponGrey .coupon_discount{
    background: #999;
  }
.pagecart-retailSheet  .couponGrey{
  background: url('/static/coupon/couponCenter1-2.png');
}
.pagecart-retailSheet  .couponRink{
  background: url('/static/coupon/couponCenter1.png');
}
.pagecart-retailSheet  .couponYellow{
  background: url('/static/coupon/couponCenter1-3.png');
}
.pagecart-retailSheet  .coupon_default_inner .couponLeft.couponRink .coupon_discount{
    background: #E95E88;
  }
.pagecart-retailSheet  .coupon_default_inner .couponLeft.couponYellow .coupon_discount{
    background: orange;
  }
.pagecart-retailSheet  .coupon_default_inner .coupon_discount .cost{
    height: 20px;
    line-height: 30px;
  }
.pagecart-retailSheet  .coupon_default_inner .coupon_discount .money{
    font-size: 26px;
    height: 30px;
    line-height: 30px;
  }  
.pagecart-retailSheet  .coupon_default_inner .couponRight{
    background-image: url('../../../static/coupon/couponCenter2.png'); 
    background-size:100% 100%; 
    padding: 10px 0;
  }
.pagecart-retailSheet  .coupon_default_inner .couponRight .coupon_content{
    padding: 0 8px;
    border-left: 1px dotted #999;
    
  }
.pagecart-retailSheet  .coupon_default_inner .couponRight .coupon_content .coupon_title{
    width: 100%;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    height: 25px;
    line-height: 23px;
  }
.pagecart-retailSheet  .coupon_default_inner .couponRight .coupon_content .coupon_title .coupon_type{
    
    padding: 2px 5px;
    font-size: 12px;
    border-radius: 3px;
  }
.pagecart-retailSheet  .coupon_default_inner .couponRight.couponGrey .coupon_content .coupon_title .coupon_type{
    border: 1px solid #999;
    color: #999;
  }
.pagecart-retailSheet  .coupon_default_inner .couponRight.couponRink .coupon_content .coupon_title .coupon_type{
    border: 1px solid #E95E88;
    color: #E95E88;
  }
.pagecart-retailSheet  .coupon_default_inner .couponRight.couponYellow .coupon_content .coupon_title .coupon_type{
    border: 1px solid orange;
    color: orange;
  }
.pagecart-retailSheet  .coupon_default_inner .couponRight .coupon_content .limit{
    font-size: 12px;
    color: #666;
    margin: 5px 0 10px;
  }
.pagecart-retailSheet  .coupon_default_inner .coupon_progress{
    display: flex;
    align-items: center;
    position: relative;
  } 
   .pagecart-retailSheet .coupon_default_inner .coupon_progress .mu-flat-button-label{padding-left: 0;padding-right: 0;}
  .pagecart-retailSheet .coupon_default_inner .coupon_progress .demo-flat-button{
        vertical-align: middle;    font-size: 14px;
  }
/* .pagecart-retailSheet  .coupon_default_inner .coupon_progress span{
 */
  /* } */
.pagecart-retailSheet  .coupon_default_inner .couponRight.couponGrey .coupon_progress span.percent{
    color: #999;
  }
.pagecart-retailSheet  .coupon_default_inner .couponRight.couponRink .coupon_progress span.percent{
    color: #E95E88;
  }
.pagecart-retailSheet  .coupon_default_inner .couponRight.couponYellow .coupon_progress span.percent{
    color: orange;
  }
.pagecart-retailSheet  .coupon_default_inner  .coupon_progress .mu-linear-progress{
    width: 40%;
  }
.pagecart-retailSheet  .coupon_default_inner .couponRight.couponGrey .coupon_progress .mu-linear-progress .mu-linear-progress-determinate{
    background: #999;
  }
.pagecart-retailSheet  .coupon_default_inner .couponRight.couponRink .coupon_progress .mu-linear-progress .mu-linear-progress-determinate{
    background: #E95E88;
  }
.pagecart-retailSheet  .coupon_default_inner .couponRight.couponYellow .coupon_progress .mu-linear-progress .mu-linear-progress-determinate{
    background: orange;
  }
.pagecart-retailSheet  .coupon_default_inner .coupon_progress .mu-flat-button{
    width: 64px;
    min-width: 64px;
    height: 26px;
    background: red;
    color: #fff;
    position: absolute;
    right: 0;
  }
.pagecart-retailSheet  .coupon_default_inner .coupon_progress .coupon_empty{
    position: absolute;
    width: 64px;
    text-align: center;
    right: 0;
    font-size: 12px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/retail/cart.vue